import axios from "axios";

const API_URL = "/dashboard/logs";


export const getLogs = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};